import { EmailResultState, EmailTemplateActionTypes, EmailTemplateState } from './Types';

export const GET_EMAIL_TEMPLATES: EmailTemplateActionTypes = 'GET_EMAIL_TEMPLATES';
export const GET_EMAIL_TEMPLATES_PENDING: EmailTemplateActionTypes = 'GET_EMAIL_TEMPLATES_PENDING';
export const GET_EMAIL_TEMPLATES_FULFILLED: EmailTemplateActionTypes = 'GET_EMAIL_TEMPLATES_FULFILLED';
export const GET_EMAIL_TEMPLATES_REJECTED: EmailTemplateActionTypes = 'GET_EMAIL_TEMPLATES_REJECTED';
export const CREATE_EMAIL_TEMPLATE: EmailTemplateActionTypes = 'CREATE_EMAIL_TEMPLATE';
export const CREATE_EMAIL_TEMPLATE_PENDING: EmailTemplateActionTypes = 'CREATE_EMAIL_TEMPLATE_PENDING';
export const CREATE_EMAIL_TEMPLATE_FULFILLED: EmailTemplateActionTypes = 'CREATE_EMAIL_TEMPLATE_FULFILLED';
export const CREATE_EMAIL_TEMPLATE_REJECTED: EmailTemplateActionTypes = 'CREATE_EMAIL_TEMPLATE_REJECTED';
export const UPDATE_EMAIL_TEMPLATE: EmailTemplateActionTypes = 'UPDATE_EMAIL_TEMPLATE';
export const UPDATE_EMAIL_TEMPLATE_PENDING: EmailTemplateActionTypes = 'UPDATE_EMAIL_TEMPLATE_PENDING';
export const UPDATE_EMAIL_TEMPLATE_FULFILLED: EmailTemplateActionTypes = 'UPDATE_EMAIL_TEMPLATE_FULFILLED';
export const UPDATE_EMAIL_TEMPLATE_REJECTED: EmailTemplateActionTypes = 'UPDATE_EMAIL_TEMPLATE_REJECTED';
export const DELETE_EMAIL_TEMPLATE: EmailTemplateActionTypes = 'DELETE_EMAIL_TEMPLATE';
export const DELETE_EMAIL_TEMPLATE_PENDING: EmailTemplateActionTypes = 'DELETE_EMAIL_TEMPLATE_PENDING';
export const DELETE_EMAIL_TEMPLATE_FULFILLED: EmailTemplateActionTypes = 'DELETE_EMAIL_TEMPLATE_FULFILLED';
export const DELETE_EMAIL_TEMPLATE_REJECTED: EmailTemplateActionTypes = 'DELETE_EMAIL_TEMPLATE_REJECTED';
export const GET_EMAIL_RESULTS: EmailTemplateActionTypes = 'GET_EMAIL_RESULTS';
export const GET_EMAIL_RESULTS_PENDING: EmailTemplateActionTypes = 'GET_EMAIL_RESULTS_PENDING';
export const GET_EMAIL_RESULTS_FULFILLED: EmailTemplateActionTypes = 'GET_EMAIL_RESULTS_FULFILLED';
export const GET_EMAIL_RESULTS_REJECTED: EmailTemplateActionTypes = 'GET_EMAIL_RESULTS_REJECTED';

export const initialEmailTemplateState: EmailTemplateState = {
  statusCode: 0,
  emailTemplates: []
};

export const initialEmailResultState: EmailResultState = {
  statusCode: 0,
  emailResults: []
};



// WEBPACK FOOTER //
// ./src/emailTemplate/Constants.tsx